import { Entities } from 'client/store'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { useMemo } from 'react'

interface UseIsShowAdditionalActionProps {
  entityParents: Entities
  entity: { type: EntityTypeEnum }
}

export const useIsShowAdditionalAction = ({
  entityParents,
  entity,
}: UseIsShowAdditionalActionProps): boolean => {
  return useMemo(() => {
    const hasBookingPaidCalendarParent = Object.values(entityParents).some(
      entityParent => entityParent.type === EntityTypeEnum.BookingPaidCalendar,
    )

    const isOfferOrPayment =
      entity.type === EntityTypeEnum.OfferPrice ||
      entity.type === EntityTypeEnum.PaymentMethod

    const isWebsiteFooter = entity.type === EntityTypeEnum.WebsiteFooter

    return (
      !(hasBookingPaidCalendarParent && isOfferOrPayment) && !isWebsiteFooter
    )
  }, [entityParents, entity])
}
